import { AlertTriangle } from 'lucide-react'
import { productReady } from '@petrotrack/shared'
import { FUEL_COLORS } from '../../utils/formatters'

// Pick which product to record (replaces the per-tank chooser).
// Products missing a tank or pump are greyed with a "Setup needed" chip —
// selecting one routes through the AppShell gate (admins → branch editor,
// managers → explanation toast).
export default function ProductSelectSheet({ products, branch, onSelect, onClose }) {
  return (
    <>
      <div className="fixed inset-0 z-[60] bg-black/50 animate-fadeIn" onClick={onClose} />
      <div className="fixed inset-x-0 bottom-0 sm:inset-0 sm:flex sm:items-center sm:justify-center z-[70] animate-slideUp sm:animate-fadeIn">
        <div className="bg-white w-full sm:w-[420px] rounded-t-2xl sm:rounded-2xl p-4 shadow-2xl">
          <h2 className="font-bold text-gray-800 mb-1">Record daily entry</h2>
          <p className="text-xs text-gray-400 mb-4">{branch?.name} — choose a product</p>
          <div className="space-y-2">
            {products.map((product) => {
              const c = FUEL_COLORS[product] || FUEL_COLORS.PMS
              const r = branch ? productReady(branch, product) : { ready: true, missing: [] }
              return (
                <button key={product} onClick={() => onSelect(product)}
                  className={`w-full flex items-center justify-between px-4 py-3 rounded-xl border transition ${
                    r.ready
                      ? 'border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                      : 'border-amber-200 bg-amber-50/60'
                  }`}>
                  <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${r.ready ? `${c.bg} ${c.text}` : 'bg-gray-100 text-gray-400'}`}>
                    {product}
                  </span>
                  {r.ready ? (
                    <span className="text-sm text-gray-400">›</span>
                  ) : (
                    <span className="flex items-center gap-1.5 text-xs font-semibold text-amber-700">
                      <AlertTriangle className="w-3.5 h-3.5" /> Setup needed — missing {r.missing.join(' & ')}
                    </span>
                  )}
                </button>
              )
            })}
          </div>
          <button onClick={onClose} className="mt-4 w-full py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-semibold hover:bg-gray-50">Cancel</button>
        </div>
      </div>
    </>
  )
}
